import React, { useEffect, useState } from "react";
import { Button, Drawer, Row, Spin } from "antd";
import './trip-details-drawer.scss';
import downLine from "../../../assets/images/helpsupport-line.svg";
import callerIcon from "../../../assets/images/caller-icon-helpsupport-2.svg";
import InvoiceRightModal from "./invoice-right-modal";
import { useTranslation } from "react-i18next";
import * as orderService from "../../../service/order/orderService";
import * as localStorageService from "../../../service/localStorageService";
import { LocalStorageKeys } from "../../../constants/localStorageKeys";
import { CommonConstants } from "../../../constants/commonConstants";
const TripDetailsDrawer = ({ orderID, setTripDetailsDrawer, isOpenTripDetailsDrawer }) => {
    const {t} = useTranslation();
    const [isInvoiceRightModalOpen,setInvoiceRightModalOpen]=useState(false)
    const [tripData, setTripData] = useState([
      

    ])
     const [orderDetails, setOrderDetails] = useState(null);
        const [loader, setLoader] = useState(false);
     useEffect(() => {
        if(orderID){
            getOrderDetails();
        }
        }, [])
    
        const getOrderDetails = () => {
            const languageISOCode=localStorageService.getValue(LocalStorageKeys.Lang) ? localStorageService.getValue(LocalStorageKeys.Lang) : CommonConstants.DefaultLanguageCode;
            setLoader(true)
            orderService.getOrderDetails(orderID,languageISOCode)
                .then((res) => {
                    if (res.status === 200) {
                        setLoader(false)
                        setOrderDetails(res?.data?.data)
                      
                    }
                })
                .catch((err) => {
    
                })
        }
    const handleClose = () => {
        setTripDetailsDrawer(false);
    };
    function getStringBeforeComma(str) {
        if (typeof str !== 'string') return '';  
        const index = str.indexOf(',');
        if (index === -1) return str; 
        return str.substring(0, index);
      }
      function getStringAfterComma(str) {
        if (typeof str !== 'string') return ''; 
        const index = str.indexOf(',');
        if (index === -1) return ''; 
        return str.substring(index + 1).trim(); 
      }
      
      
    return (
        <Drawer
            title={<span>{t("NEED_HELP_ORDER_ID")} {orderID}</span>}
            visible={isOpenTripDetailsDrawer}
            onClose={handleClose}
            width={510}

        >
           {loader?<Spin style={{ marginLeft: "50%", marginTop: "10%" }}></Spin>: <div className="trip-details-wrapper">

                <span className="tripDetails-title">{t("NEED_HELP_TRIP_DETAILS")}</span>

                <div className="from-to-div-wrapper">
                    <div className="imgdiv"><img src={downLine} className="down-arrow" /></div>
                    <div className="from-to-container">
                        <div className="from-country-wrapper">
                            <span className="first">{getStringBeforeComma(orderDetails?.fromCity)}</span>
                            <span className="second">{getStringAfterComma(orderDetails?.fromCity)}</span>
                        </div>
                        <div className="from-country-wrapper">
                            <span className="first">{getStringBeforeComma(orderDetails?.toCity)}</span>
                            <span className="second">{getStringAfterComma(orderDetails?.toCity)}</span>
                        </div>
                    </div>
                </div>
                {orderDetails?.trips?.map((item, index) => {
                    return (
                        <div className="trip-details-wrapper">
                            <Row className="truckno-row">
                                <span className="truckNo">{t("NEED_HELP_TRUCK_NO")} <span className="truck-no-value">{item?.assetRegistrationNumber}</span></span>
                                <span className="status-wrapper">
                                    {/* {item?.status} */}
                                    {item?.localizeStatusName ? item?.localizeStatusName:item?.status}
                                    </span>
                            </Row>
                            <Row className="truckno-row">
                                <div className="driver-name-wrapper">
                                    <div className="driverName">
                                    {t("NEED_HELP_DRIVER_NAME")}
                                    </div>
                                    <div className="driver-name-value">{item?.driverName}</div>
                                </div>
                                <div className="driver-contact">
                                    <img src={callerIcon} /> +{item?.driverContactDetails?.countryCode} {item?.driverContactDetails?.mobileNumber}
                                </div>
                            </Row>
                            <Row className="totalAmount-row">
                                <div className="total-amount">{item?.tripTotalCost[0]?.currency} {item?.tripTotalCost[0]?.amount}</div> <span className="total-amount-desc">{t("NEED_HELP_TOTAL_EARNINGS")}</span>
                            </Row>
                        </div>
                    )
                })}
                <Row className="button-row-wrapper">
                    <Button className="cancel-btn" onClick={()=>setTripDetailsDrawer(false)}>{t("COMMON_CANCEL_BTN")}</Button>
                    <Button type="primary" className="raise-issue-btn" onClick={()=>setInvoiceRightModalOpen(true)}>{t("NEED_HELP_RAISE_ISSUE")}</Button>
                </Row>
            </div>}
{ isInvoiceRightModalOpen && <InvoiceRightModal OrderId={orderID} isOpen={isInvoiceRightModalOpen} setIsOpen={setInvoiceRightModalOpen} setTripDetailsDrawer={setTripDetailsDrawer} />}

        </Drawer>
    );
};

export default TripDetailsDrawer;
